<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="合同名称">
                  <el-input style="width: 200px" v-model="queryForm.contractName"></el-input>
              </el-form-item>
              <el-form-item label="文字字段">
                  <el-input style="width: 200px" v-model="queryForm.textFields"></el-input>
              </el-form-item>
              <el-form-item label="需要签名">
                  <!-- <el-input style="width: 200px" v-model="queryForm.needSign"></el-input> -->
                  <el-select placeholder="请选择状态"  clearable style="width: 200px"
                      size="small" v-model="queryForm.needSign">
                      <el-option v-for='(item, index) in yesNoList' :key='index' :label="item.value" :value="item.key"></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="签名字段" v-if="queryForm.needSign == 1">
                  <el-input style="width: 200px" v-model="queryForm.signField"></el-input>
              </el-form-item>
              <el-form-item label="需要签章">
                  <!-- <el-input style="width: 200px" v-model="queryForm.needStamp"></el-input> -->
                  <el-select placeholder="请选择状态"  clearable style="width: 200px"
                      size="small" v-model="queryForm.needStamp">
                      <el-option v-for='(item, index) in yesNoList' :key='index' :label="item.value" :value="item.key"></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="签章字段" v-if="queryForm.needStamp == 1">
                  <el-input style="width: 200px" v-model="queryForm.stampField"></el-input>
              </el-form-item>
              <el-form-item label="签署对象">
                  <!-- <el-input  v-model="queryForm.signTarget"></el-input> -->
                  <el-select
                      v-model="queryForm.signTarget"
                      placeholder="请选择签署对象"
                      clearable
                      size="small"
                      style="width: 200px"
                  >
                      <el-option v-for="item in esignTarget" :key="item.key" :label="item.value" :value="item.key"> </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="对象ID" v-if="queryForm.signTarget != 1 && queryForm.signTarget != 4">
                  <!-- <el-input style="width: 200px" v-model="queryForm.targetId"></el-input> -->
                  <GridSelect
                      title='选择用户'
                      labelName='userName'
                      labelValue='id'
                      :disabled="queryForm.signTarget == ''"
                      v-if="queryForm.signTarget == 2"
                      :value='queryForm.targetId'
                      :limit='1'
                      style='width: 200px'
                      size='small'
                      placeholder='请选择用户'
                      @getValue='getSeachValuebrandId'
                      :columns="USER_code"
                      :searchs="USER_search"
                      dataListUrl='/mpp/user/findList'
                      entityBeanName='mppUser'
                      queryEntityUrl='/mpp/user/get'
                  >
                  </GridSelect>
                  <el-select
                      style="width: 200px;"
                      clearable
                      v-model='queryForm.targetId'
                      :disabled="queryForm.signTarget == ''"
                      size='small'
                      v-else-if="queryForm.signTarget == 3"
                      placeholder='请选择用户等级'
                  >
                      <el-option v-for='(item,index) in GradeAll' :label='item.gradeName' :value='item.id'></el-option>
                  </el-select>
                  <el-select
                      style="width: 200px;"
                      clearable
                      v-model='queryForm.targetId'
                      :disabled="queryForm.signTarget == ''"
                      size='small'
                      v-else
                      placeholder='请选择代理等级'
                  >
                      <el-option v-for='(item,index) in AgentLevelAll' :label='item.agentName' :value='item.id'></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getEsignContractList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addEsignContract"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editEsignContract(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteEsignContract(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          title="下载模板"
          class="icon-box"
          @click="importTemplate"
        >
          <Icon color="#606266">
            <ArrowDown />
          </Icon>
        </span>
        <span
          class="icon-box"
          title="导入数据"
          @click="isImport"
        >
          <Icon color="#606266">
            <ArrowExportUp24Regular />
          </Icon>
        </span>
        <span
          title="导出数据"
          class="icon-box"
          @click="exportEsignContractList"
        >
          <Icon color="#606266">
            <ArrowDownload24Regular />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshEsignContractList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="esignContractList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="contractName"
        label="合同名称"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="contractFile"
        label="合同模板文件"
        width="180"
      >
        <template slot-scope="scop">
          <!-- <div style="text-align: left;"> -->
            <span class='downloadFile' @click='downloadFile(scop.row.contractFile,scop.row.contractName)'>查看合同</span>
          <!-- </div> -->
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="textFields"
        label="文字字段"
        width="180"
      >
        <template slot-scope="scop">
          <div style="text-align: left;" v-for="item in items(scop.row.textFields)">
            {{ item.key }} : {{ item.value }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="needSign"
        label="需要签名"
        width="180"
      >
        <template slot-scope="scop">
          <div style='text-align: left;'>
            <div>需要签名：{{ computeYesNo(scop.row.needSign) }}</div>
            <div v-if="scop.row.needSign == 1">
              签名字段：{{scop.row.signField}}
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="needStamp"
        label="需要签章"
        width="180"
      >
        <template slot-scope="scop">
          <div style='text-align: left;'>
            <div>需要签章：{{ computeYesNo(scop.row.needStamp) }}</div>
            <div v-if="scop.row.needStamp == 1">
              签章字段：{{scop.row.stampField}}
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="signTarget"
        label="签署对象"
        width="180"
      >
        <template slot-scope="scop">
          {{ computeesignTarget(scop.row.signTarget) }}
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="targetId"
        label="对象ID"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkEsignContract(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editEsignContract(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteEsignContract(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="esignContractStates[esignContractState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="esignContract"
          ref="esignContractForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="合同名称"
            prop="contractName"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="esignContract.contractName"
              :disabled="esignContractState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="文字字段"
            prop="textFields"
          >
            <textField size="small"
              style="width: 200px"
              placeholder="请输入字段"
              :feild="{key:false,value:false,btn:false}"
              @getValue="getTextFieldValue"
              :value="esignContract.textFields"
              :disabled="esignContractState == 'check'">
            </textField>
          </el-form-item>
          <el-form-item
            label="需要签名"
            prop="needSign"
          >
            <el-select placeholder="请选择状态"  clearable style="width: 200px" :disabled="esignContractState == 'check'"
                size="small" v-model="esignContract.needSign">
                <el-option v-for='(item, index) in yesNoList' :key='index' :label="item.value" :value="item.key"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="签名字段"
            prop="signField"
            v-if="esignContract.needSign == 1"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="esignContract.signField"
              :disabled="esignContractState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="需要签章"
            prop="needStamp"
          >
            <el-select placeholder="请选择状态"  clearable style="width: 200px" :disabled="esignContractState == 'check'"
                size="small" v-model="esignContract.needStamp">
                <el-option v-for='(item, index) in yesNoList' :key='index' :label="item.value" :value="item.key"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="签章字段"
            prop="stampField"
            v-if="esignContract.needStamp == 1"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="esignContract.stampField"
              :disabled="esignContractState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="签署对象"
            prop="signTarget"
          >
            <el-select
                v-model="esignContract.signTarget"
                :disabled="esignContractState == 'check'"
                placeholder="请选择签署对象"
                clearable
                size="small"
                style="width: 200px"
            >
                <el-option v-for="item in esignTarget" :key="item.key" :label="item.value" :value="item.key"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="对象ID"
            prop="targetId"
            v-if="esignContract.signTarget != 1 && esignContract.signTarget != 4"
          >
            <GridSelect
                title='选择用户'
                labelName='userName'
                labelValue='id'
                :disabled="esignContract.signTarget == '' || esignContractState == 'check'"
                v-if="esignContract.signTarget == 2"
                :value='esignContract.targetId'
                :limit='1'
                style='width: 200px'
                size='small'
                placeholder='请选择用户'
                @getValue='getValueUser'
                :columns="USER_code"
                :searchs="USER_search"
                dataListUrl='/mpp/user/findList'
                entityBeanName='mppUser'
                queryEntityUrl='/mpp/user/get'
            >
            </GridSelect>
            <el-select
                style="width: 200px;"
                clearable
                v-model='esignContract.targetId'
                :disabled="esignContract.signTarget == '' || esignContractState == 'check'"
                size='small'
                v-else-if="esignContract.signTarget == 3"
                placeholder='请选择用户等级'
            >
                <el-option v-for='(item,index) in GradeAll' :label='item.gradeName' :value='item.id'></el-option>
            </el-select>
            <el-select
                style="width: 200px;"
                clearable
                v-model='esignContract.targetId'
                :disabled="esignContract.signTarget == '' || esignContractState == 'check'"
                size='small'
                v-else
                placeholder='请选择代理等级'
            >
                <el-option v-for='(item,index) in AgentLevelAll' :label='item.agentName' :value='item.id'></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="合同模板文件"
            prop="contractFile"
          >
            <el-input :disabled="esignContractState == 'check'" v-model="esignContract.contractFile" size="small" style="width: 118px;"></el-input>
              <el-button :disabled="esignContractState == 'check'" type="primary" size="small" style="margin-left: 2px;" @click="uploadImages1">上传文件
                  <el-upload :action="action" v-show="false" ref="uploads1" :headers="header" :before-upload="beforeImageUpload1"
                    :disabled="esignContractState == 'check'" class="avatar-uploader" :show-file-list="false"
                    :http-request="uploadImage2">
                    <el-button type="primary" size="small" class="as1">上传</el-button>
                  </el-upload>
              </el-button>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="esignContractState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun, upload } from '@/utils/request.js';
import GridSelect from '@/components/gridselect';
import { UPLOAD_PATH, UPLOAD_API, USER, USER_SEARCH } from '@/utils/constant.js';
import textField from '@/components/Contract/textField.vue';
export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        GridSelect,
        textField
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetEsignContractList();
                    this.getEsignContractList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetEsignContractList();
                    this.getEsignContractList();
                    this.$emit('resetCheckState');
                }
            },
            'queryForm.signTarget':{
                handler(val,old) {
                  if(val != old){
                    this.queryForm.targetId = '';
                  }
                },
            },
            'esignContract.signTarget':{
                handler(val,old) {
                  if(val != old){
                    this.esignContract.targetId = '';
                  }
                },
            },
        },
    data() {
            return {
                queryForm:{
                     contractName: '', //合同名称
                     contractFile: '', //合同模板文件
                     textFields: '', //文字字段
                     needSign: '', //需要签名
                     needStamp: '', //需要签章
                     signTarget: '', //签署对象
                     targetId: '', //对象ID
                     signField: '',
                     stampField: '',
                },
                header: {
                  token: localStorage.getItem('token')
                },
                action: UPLOAD_API + UPLOAD_PATH,
                USER_code: USER,
                USER_search: USER_SEARCH,
                yesNoList: [],
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                esignContractState: 'add',
                esignContractStates: {
                    add: '新建合同',
                    check: '查看合同',
                    edit: '修改合同'
                },

                multipleSelection: [],
                esignContractList: [],
                esignContract: {
                    id: '', //ID
                    contractName: '', //合同名称
                    contractFile: '', //合同模板文件
                    textFields: '', //文字字段
                    needSign: '', //需要签名
                    needStamp: '', //需要签章
                    signTarget: '', //签署对象
                    targetId: '', //对象ID
                    signField: '',
                    stampField: '',
                },
                btnLoading: false,
                esignTarget: [],
                rules: {
                    contractName: [{ required: true, message: '合同名称不能为空', trigger: 'blur' }],
                    contractFile: [{ required: true, message: '合同模板文件不能为空', trigger: 'blur' }],
                    textFields: [{ required: true, message: '文字字段不能为空', trigger: 'blur' }],
                    needSign: [{ required: true, message: '需要签名不能为空', trigger: 'blur' }],
                    needStamp: [{ required: true, message: '需要签章不能为空', trigger: 'blur' }],
                    signTarget: [{ required: true, message: '签署对象不能为空', trigger: 'blur' }],
                    targetId: [{ required: true, message: '对象ID不能为空', trigger: 'blur' }],
                    signField: [{ required: true, message: '签名字段不能为空', trigger: 'blur' }],
                    stampField: [{ required: true, message: '签章字段不能为空', trigger: 'blur' }],
                },
                GradeAll: [],
                AgentLevelAll:[]
            };
        },
        created() {
            this.getEsignContractList();
            this.getesignTarget();
            this.getYesNo();
            this.getAll();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            // 下载文件
            downloadFile(url, fileName) {
              var anchorElement = document.createElement('a');
              anchorElement.href = url;
              anchorElement.download = fileName;
              anchorElement.target = "_blank";
              anchorElement.style.display = "none";
              document.body.appendChild(anchorElement);
              anchorElement.click();
              document.body.removeChild(anchorElement);
            },
            uploadImages1(id) {
                this.$refs.uploads1.$el.querySelector(".as1").click()
            },
            items(val){
              let array = val.replace(/&quot;/g, '"');
              array = JSON.parse(array)
              return array
            },
            getTextFieldValue(val){
              console.log(val)
              this.esignContract.textFields = val;
            },
            beforeImageUpload1(file) {
              const isLt2M = file.size / 1024 / 1024 < 500;
              if (!isLt2M) {
                this.$message.error('上传文件大小不能超过 500MB!');
              }
              return isLt2M;
            },
            //上传文件
            uploadImage2(params) {
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              upload('/mpp/file/upload', formData).then((res) => {
                if (res.success) {
                  this.esignContract.contractFile = res.url;
                }else{
                  this.$message.error(res.msg);
                }
              });
            },
            // 获取所有等级
            getAll(){
              get('mpp/grade/findAll', {
              }).then((res) => {
                this.GradeAll = res.list;
              });
              get('mpp/mppagentlevel/findAll', {
              }).then((res) => {
                  if (res.success) {
                      // console.log(res.enumList)
                      this.AgentLevelAll = res.list
                  }
              })
            },
            getSeachValuebrandId(value) {
              this.queryForm.targetId = value;
            },
            getValueUser(value) {
              this.esignContract.targetId = value
              console.log(this.esignContract.targetId)
            },
            getYesNo(){
              // 是否显示
              get('/mpp/utils/getEnum', {
              enumType: 'yes_no',
              }).then((res) => {
                  if (res.success) {
                      // console.log(res.enumList)
                      this.yesNoList = res.enumList
                  }
              })
            },
            computeYesNo(val){
              for (const key in this.yesNoList) {
                if (this.yesNoList[key].key == val) {
                  return this.yesNoList[key].value;
                }
              }
            },
            // 获取枚举
            getesignTarget() {
                get('/mpp/utils/getEnum', {
                    enumType: 'esign_target'
                }).then((res) => {
                    if (res.success && res.code === 200) {
                        this.esignTarget = res.enumList;
                    }
                });
            },
            // 计算OrderPayType
            computeesignTarget(type) {
                for (let i = 0; i < this.esignTarget.length; i++) {
                    if (this.esignTarget[i].key === type) {
                        return this.esignTarget[i].value;
                    }
                }
            },
            resetEsignContractList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.esignContractList = [];
            },
            resetDialog() {
                this.esignContractState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      contractName: '', //合同名称
                      contractFile: '', //合同模板文件
                      textFields: '', //文字字段
                      needSign: '', //需要签名
                      needStamp: '', //需要签章
                      signTarget: '', //签署对象
                      targetId: '', //对象ID
                      signField: '',
                      stampField: '',
                };
                this.getEsignContractList();
            },
            closeDialog() {
                this.showDialog = false
                this.esignContract = {
                      id: '', //ID
                      contractName: '', //合同名称
                      contractFile: '', //合同模板文件
                      textFields: '', //文字字段
                      needSign: '', //需要签名
                      needStamp: '', //需要签章
                      signTarget: '', //签署对象
                      targetId: '', //对象ID
                      signField: '',
                      stampField: ''
                };
            },
            submitForm() {
                if (this.esignContractState == 'add') {
                    this.$refs.esignContractForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            console.log(this.esignContract);
                            this.esignContract.targetId = this.esignContract.signTarget == 1 || this.esignContract.signTarget == 4 ? '' : this.esignContract.targetId
                            post(`/esign/contract/add`,{ ...this.esignContract }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetEsignContractList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.esignContractState == 'edit') {
                    this.$refs.esignContractForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            delete this.esignContract.updateTime
                            this.esignContract.targetId = this.esignContract.signTarget == 1 || this.esignContract.signTarget == 4 ? '' : this.esignContract.targetId
                            let obj = JSON.parse(JSON.stringify(this.esignContract))
                            obj.textFields = obj.textFields.replace(/&quot;/g, '"');
                            console.log(obj)
                            post(`/esign/contract/edit`,{ ...obj }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetEsignContractList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addEsignContract() {
                this.showDialog = true;
                this.esignContractState = 'add';
            },
            checkEsignContract(esignContractId) {
                console.log(esignContractId);
                this.currentEsignContractId = esignContractId;

                this.getEsignContractById();
                this.showDialog = true;
                this.esignContractState = 'check';
            },
            editEsignContract(esignContractId) {
                console.log('esignContract', esignContractId);
                if (esignContractId) {
                    this.currentEsignContractId = esignContractId;
                    this.getEsignContractById();
                } else {
                    this.esignContract = { ...this.esignContract, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.esignContractState = 'edit';
            },
            deleteEsignContract(esignContractId) {
                let ids = '';
                if (esignContractId) {
                    ids = esignContractId;
                } else {
                    ids = this.multipleSelection.map((esignContract) => esignContract.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/esign/contract/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetEsignContractList();
                                this.getEsignContractList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshEsignContractList() {
                this.resetEsignContractList();
                this.getEsignContractList();
            },
            getEsignContractList(query = {}) {
                this.loading = true;
                get(`/esign/contract/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.esignContractList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getEsignContractById() {
                get(`/esign/contract/get`,{ id: this.currentEsignContractId }).then((res) =>{
                    if(res.success){
                      this.esignContract = { ...this.esignContract, ...res.esignContract };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportEsignContractList() {
                //this.btnLoading = true;
                exprotExcel(`/esign/contract/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/esign/contract/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/esign/contract/importData`,formData);
              this.refreshEsignContractList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getEsignContractList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getEsignContractList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}

.avatar {
  width: 200px;
  height: 200px;
  display: block;
}

::v-deep .el-upload--text {
  width: 200px;
  height: 200px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 200px;
  height: 200px;
  line-height: 200px;
  text-align: center;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
.downloadFile{
    cursor: pointer;
}
.downloadFile:hover{
    color: #409eff;
}
</style>